import React, { Component } from 'react';
import TransportsEntry from './TransportsEntry';
import TransportsByLotContent from './ByLot/TransportsByLotContent';
import TransportsWRTContent from './WaitingRequest/TransportsWRTContent';
import TransportsWADContent from './WaitingArrival/TransportsWADContent';
import TransportsAtDContent from './AtDestination/TransportsAtDContent';


export class TransportsContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      content: this.props.showContent
    };
  }

  handleChangeContent = (newContent) => {
    this.setState({
      content: newContent
    });
  };


  render() {
    return (
      <div>
        {this.state.content === 'transports' ?
          <TransportsEntry handleChangeContent={this.handleChangeContent.bind(this)} />
          : this.state.content === 'transportsByLot' ?
            <TransportsByLotContent handleChangeContent={this.handleChangeContent.bind(this)} showContent={this.state.content} />
            : this.state.content === 'transportsWaitingRequest' ?
              <TransportsWRTContent handleChangeContent={this.handleChangeContent.bind(this)} showContent={this.state.content} />
              : this.state.content === 'transportsWaitingArrival' ?
                <TransportsWADContent handleChangeContent={this.handleChangeContent.bind(this)} showContent={this.state.content} />
                : this.state.content === 'transportsAtDestination' ?
                  <TransportsAtDContent handleChangeContent={this.handleChangeContent.bind(this)} showContent={this.state.content} />
                  : null}
      </div>
    )
  }
}

export default TransportsContent;


// WEBPACK FOOTER //
// ./src/components/Transports/TransportsContent.js